<template>
	<div class="Layout d-flex flex-column j-start a-center">
		<nav-bar></nav-bar>
		<div class="view">
			<transition name="fade-in">
				<router-view />
			</transition>
			<bottom></bottom>
		</div>
		
	</div>
</template>

<script>
	import navBar from './navBar.vue'
	import bottom from './bottom.vue'
	export default {
		components: {
			navBar,
			bottom
		},
		data() {
			return {
				user_info: ''
			}
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style scoped lang="less">
	.fade-in-enter-active {
		animation: fade-in .5s ease;
	}

	.fade-in-leave-active {
		animation: fade-in .5s ease reverse;
	}

	@keyframes fade-in {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.Layout {
		height: 100vh;
		width: 100%;
		background: #F4F4F4;
		overflow: hidden;

		.view {
			flex: 1;
			height: 100%;
			flex-shrink: 0;
			padding: 0 1.44rem 1.44rem 1.44rem;
			box-sizing: border-box;
			width: 100%;
			overflow: auto;
		}
	}
</style>
